module.exports = __webpack_public_path__ + "static/media/trello-board.6c60fbfe.png";